export default {
    filter: 'Filter',
    fields: {
        date_from: {
            label: 'Od datuma',
            placeholder: 'Unesite datum',
            tool_tip_message: 'Prvi dan rasporeda',
        },
        date_to: {
            label: 'Do datuma',
            placeholder: 'Unesite datum',
            tool_tip_message: 'Poslednji dan rasporeda',
        },
        status: {
            label: 'Status',
            placeholder: 'Izaberite status',
        },
        order_by: {
            label: 'Sortirajte po',
            placeholder: 'Izaberi sortiranje',
        },
        user: {
            label: 'Korisnik',
            placeholder: 'Unesite korisnika',
        },
        company: {
            label: 'Kompanija',
            placeholder: 'Unesite kompaniju',
        },
        year: {
            label: 'Godina',
            placeholder: 'Izaberite godinu',
        },
        location: {
            label: 'Sve lokacije',
            placeholder: 'Sve lokacije',
        },
    },
    sort: {
        sort: 'Sortiraj',
        createdAt_ASC: 'Kreiranom datumu - Najstariji',
        createdAt_DESC: 'Kreiranom datumu - Najnoviji',
        updatedAt_ASC: 'Ažuriranom datumu - Najstariji',
        updatedAt_DESC: 'Ažuriranom datumu - Najnoviji',
        reservationTime_ASC: 'Vreme rezervacije	- Najstariji',
        reservationTime_DESC: 'Vreme rezervacije - Najnoviji',
        firstName_ASC: 'Ime - Rastuće',
        firstName_DESC: 'Ime - Opadajuće',
        lastName_ASC: 'Prezime - Rastuće',
        lastName_DESC: 'Prezime - Opadajuće',
    },
}
